import styled from 'styled-components';
import { colorGetter } from '../../../../../../utils';
export var Thumb = styled.div.attrs(function (_ref) {
  var value = _ref.value;
  return {
    style: {
      left: "calc(" + value + "%)"
    }
  };
}).withConfig({
  displayName: "styled__Thumb",
  componentId: "sc-6meuil-0"
})(["z-index:10;position:absolute;width:16px;height:16px;top:50%;transform:translate(-50%,-50%);cursor:ew-resize;&::before{content:'';position:absolute;box-sizing:border-box;width:100%;height:16px;border:", ";background:", ";border-radius:50%;z-index:10;box-shadow:0 1px 10px rgba(0,0,0,0.12);}&::after{height:", ";left:50%;transform:translateX(-50%);content:'';position:absolute;border-left:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return "2px solid " + theme.colors.base.white;
}, function (_ref3) {
  var theme = _ref3.theme,
      color = _ref3.color;
  return colorGetter(theme)(color);
}, function (_ref4) {
  var _ref4$height = _ref4.height,
      height = _ref4$height === void 0 ? '100%' : _ref4$height;
  return height;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "2px solid " + theme.colors.secondary.lighter;
});